var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 6.2 6.2",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.211 3.15c.039.168-.145.295-.288.206l-.488-.305-.61.975c-.159.255.025.587.325.587h.623c.08 0 .144.064.144.144v.479c0 .08-.064.144-.144.144h-.621c-.903 0-1.454-.995-.976-1.76l.61-.975-.489-.305c-.145-.09-.107-.311.059-.35l1.32-.304c.104-.024.207.04.23.143l.305 1.321zM3.392.958l.495.792-.488.305c-.145.09-.108.311.058.35l1.321.304c.104.024.206-.04.23-.143l.305-1.321c.038-.166-.144-.296-.288-.206l-.488.305-.494-.792c-.45-.72-1.5-.72-1.951 0l-.215.345c-.042.067-.022.156.045.198l.407.254c.067.042.156.021.198-.046l.215-.344c.152-.244.503-.236.65 0zM5.958 3.62l-.33-.528c-.041-.067-.13-.088-.198-.046l-.405.254c-.068.042-.088.13-.046.198l.33.528c.16.254-.024.587-.325.587h-1.15v-.575c0-.17-.206-.256-.327-.136l-.959.959c-.075.075-.075.196 0 .27l.959.96c.12.12.327.035.327-.136V5.38h1.149c.902 0 1.454-.995.975-1.76z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycle);
export default __webpack_public_path__ + "static/media/recycle.114d95a2876683ecd7f48eb3ea4ec6e5.svg";
export { ForwardRef as ReactComponent };